import { view } from '@yola/ws-sdk';

const restoreScrollPosition = (position) => {
  view.helpers.smoothScroll.scrollToPosition(position, 0);
};

export default restoreScrollPosition;
